import React from 'react';

const LocationAndHours: React.FC = () => {
  return (
    <section className="w-full bg-white py-8">
      {/* Centered container with a max width */}
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* LEFT COLUMN: Address + Embedded Map */}
          <div className="flex flex-col space-y-4">
            <a
              href="https://maps.app.goo.gl/zSPGCo7ESQsUVDE77"
              target="_blank"
              rel="noopener noreferrer"
              className="text-maroon font-prosto text-lg underline"
            >
              1230 State St. STE C, Santa Barbara, CA 93101
            </a>

            <div className="w-full h-[450px] overflow-hidden">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d205.69326146167714!2d-119.7055509!3d34.4244135!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80e915002cffbe2b%3A0x22db976408faf77b!2sSanta%20Playa%20Mariscos!5e0!3m2!1sen!2sus!4v1742425653442!5m2!1sen!2sus"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Santa Playa Mariscos Map"
              />
            </div>
          </div>

          {/* RIGHT COLUMN: "Open Daily" image + Hours */}
          <div className="flex flex-col items-center justify-center space-y-4">
            <img
              src="https://santaplaya-bucket.s3.amazonaws.com/openDaily.webp"
              alt="Open Daily"
              className="max-w-xs"
            />
            <p className="text-sea font-prosto text-center text-xl">
              11 AM - 9 PM
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationAndHours;
